import api from "../lib/api";
import { Pagination } from "../models/base.model";
import {
  GetSentimentParam,
  Sentiment,
  SentimentConfig,
  SentimentKeyword,
  SentimentSummary,
  SentimentTypeEnum,
} from "../models/sentiment.model";

export async function getSentiments(filter: GetSentimentParam & Pagination): Promise<{
  sentiments: Sentiment[];
  offset?: object;
}> {
  const res = await api<{
    sentiments: Sentiment[];
    offset?: object;
  }>({
    url: `/sentiments`,
    method: "POST",
    data: {
      ...filter,
      limit: 10,
    },
  });
  return res;
}

export function getSentimentsSummary(filter: GetSentimentParam) {
  return api<SentimentSummary>({
    url: `/sentiments/summary`,
    method: "POST",
    data: filter,
  });
}

export async function generateSentimentsCsv(filter: GetSentimentParam & Pagination & { sentimentType?: SentimentTypeEnum }) {
  return api<{
    success: boolean;
    message: string;
  }>({
    url: `/sentiments/generate-csv`,
    method: "POST",
    data: filter,
  });
}

export async function downloadSentiments(key: string) {
  return api<{
    url: string;
  }>({
    url: `/sentiments/download/${key}`,
    method: "GET",
  });
}

export async function getSentimentKeywords(filter: GetSentimentParam) {
  const res = await api<{
    keywords: SentimentKeyword[];
  }>({
    url: `/sentiment/keywords`,
    method: "POST",
    data: filter,
  });
  return res.keywords;
}

export async function getRelatedSentiments(param: { sks: string[] }) {
  return api<{ sentiments: Sentiment[] }>({
    url: "/sentiments/bySKs",
    method: "POST",
    data: param,
  });
}

export async function getSentimentKeywordGroupConfig() {
  const res = await api<{
    config: { map?: SentimentConfig };
  }>({
    url: "/sentiment/config",
    method: "GET",
  });
  return res.config?.map || {};
}

export async function updateSentimentType(sentiment: Partial<Sentiment>) {
  return api<{ sentiment: Sentiment }>({
    url: "/sentiment/type",
    method: "PATCH",
    data: {
      id: sentiment.id,
      type: sentiment.type,
      keywords: sentiment.keywords,
      sk: `${sentiment.submitId}#${sentiment.questionKey}`,
    },
  });
}
